import type { PromoCandidate } from '@supply-mover-2-0/shared';
import { PromoTile } from './PromoTile';

/**
 * Side-by-side pair of feature tiles. Renders the first two selected
 * promos.
 */
export function PromoTwoUpWidget({
	promos,
	density,
	onLikelyStaleUrl,
}: {
	promos: Array<PromoCandidate>;
	density?: 'standard' | 'compact';
	onLikelyStaleUrl?: () => void;
}): JSX.Element | null {
	const slice = promos.slice(0, 2);
	if (slice.length === 0) return null;
	return (
		<div className="grid grid-cols-1 md:grid-cols-2 gap-3 w-full h-full">
			{slice.map((p) => (
				<PromoTile
					key={p.id}
					promo={p as never}
					size="feature"
					density={density}
					onLikelyStaleUrl={onLikelyStaleUrl}
				/>
			))}
		</div>
	);
}
